import { useEffect } from 'react';
export var FooterThemeChanger = function FooterThemeChanger(_ref) {
  var theme = _ref.theme;
  useEffect(function () {
    if (theme) {
      var event = new CustomEvent('footerThemeChange', {
        detail: theme
      });
      window.dispatchEvent(event);
    }
  }, [theme]);
  return null;
};